import { Injectable } from '@angular/core';
import { ServiceRepository } from '../service-repository'
import { HttpParams, HttpErrorResponse } from "@angular/common/http";
import { Offering } from '../../Model/offerings/offering.model';
import { Observable, throwError } from 'rxjs';
import { map, filter, catchError, mergeMap } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class OfferingService {

  constructor(
    private _repositoryService: ServiceRepository
  ) { }

  getOfferingDetailsOnAppType(AppType:string, userId:string): Observable<Offering[]> {
    let params = new HttpParams();
  
    return this._repositoryService.getAll<Offering[]>(  
    '/api/Offering/GetOfferingDetails/' + AppType +"/" + userId ,params)   
      .pipe(
        map(data => data.map(data => new Offering().deserialize(data))),
        catchError( error => {
                    return throwError( error );
        })
      )
        }
  getOfferingDetailsOnAppType1(AppType:string, userId:string): Observable<Offering> {
    let params = new HttpParams();  
    return this._repositoryService.getAll<Offering>(  
    '/api/Offering/GetOfferingDetails/' + AppType +"/" + userId ,params)
   
      .pipe(
        map(data => new Offering().deserialize(data)))
        catchError( error => {
          return throwError( error );
        })      
  }

 
}
